import { createTheme } from '@material-ui/core/styles';
import * as R from 'ramda';
import baseTheme, { baseMuiTheme } from './base-theme';
import RobotImg from '@assets/images/brad-sql-bot.png';

export const muiTheme = createTheme({
  ...baseMuiTheme,
  palette: {
    ...baseMuiTheme.palette,
    primary: {
      main: '#448c67',
      light: '#485cc7',
    },
  },
  typography: {
    ...baseMuiTheme.typography,
    h4: {
      fontWeight: 500,
      color: '#fff',
      textTransform: 'uppercase',
    },
  },
});

export default R.mergeDeepRight(baseTheme, {
  name: 'BradSQL',
  header: {
    background: 'linear-gradient(to right, #448c67 0%, #485cc7 45%)',
    color: '#fff',
    titleColor: '#fff',
    height: '64px',
    imgSrc: RobotImg,
    logo: {
      url: RobotImg,
      width: '40px',
      height: '40px',
      marginRight: '12px',
    },
    productName: {
      color: '#fff',
      fontSize: '20px',
      fontWeight: 500,
      display: 'flex',
      alignItems: 'center',
    },
  },
});
